var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCargaexcedida(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_556_3881",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_556_3881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0003 56.6665C40.9448 56.6665 41.7364 56.3471 42.3753 55.7082C43.0142 55.0693 43.3337 54.2776 43.3337 53.3332C43.3337 52.3887 43.0142 51.5971 42.3753 50.9582C41.7364 50.3193 40.9448 49.9998 40.0003 49.9998C39.0559 49.9998 38.2642 50.3193 37.6253 50.9582C36.9864 51.5971 36.667 52.3887 36.667 53.3332C36.667 54.2776 36.9864 55.0693 37.6253 55.7082C38.2642 56.3471 39.0559 56.6665 40.0003 56.6665ZM36.667 43.3332H43.3337V23.3332H36.667V43.3332ZM40.0003 73.3332C35.3892 73.3332 31.0559 72.4582 27.0003 70.7082C22.9448 68.9582 19.417 66.5832 16.417 63.5832C13.417 60.5832 11.042 57.0554 9.29199 52.9998C7.54199 48.9443 6.66699 44.6109 6.66699 39.9998C6.66699 35.3887 7.54199 31.0554 9.29199 26.9998C11.042 22.9443 13.417 19.4165 16.417 16.4165C19.417 13.4165 22.9448 11.0415 27.0003 9.2915C31.0559 7.5415 35.3892 6.6665 40.0003 6.6665C44.6114 6.6665 48.9448 7.5415 53.0003 9.2915C57.0559 11.0415 60.5837 13.4165 63.5837 16.4165C66.5837 19.4165 68.9587 22.9443 70.7087 26.9998C72.4587 31.0554 73.3337 35.3887 73.3337 39.9998C73.3337 44.6109 72.4587 48.9443 70.7087 52.9998C68.9587 57.0554 66.5837 60.5832 63.5837 63.5832C60.5837 66.5832 57.0559 68.9582 53.0003 70.7082C48.9448 72.4582 44.6114 73.3332 40.0003 73.3332ZM40.0003 66.6665C47.4448 66.6665 53.7503 64.0832 58.917 58.9165C64.0837 53.7498 66.667 47.4443 66.667 39.9998C66.667 32.5554 64.0837 26.2498 58.917 21.0832C53.7503 15.9165 47.4448 13.3332 40.0003 13.3332C32.5559 13.3332 26.2503 15.9165 21.0837 21.0832C15.917 26.2498 13.3337 32.5554 13.3337 39.9998C13.3337 47.4443 15.917 53.7498 21.0837 58.9165C26.2503 64.0832 32.5559 66.6665 40.0003 66.6665Z",
    fill: "#F36969"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargaexcedida);
export default __webpack_public_path__ + "static/media/carga excedida.80857afab8ec56ac0505538510a01721.svg";
export { ForwardRef as ReactComponent };